"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSocialAuthUrlDto = instanceOfSocialAuthUrlDto;
exports.SocialAuthUrlDtoFromJSON = SocialAuthUrlDtoFromJSON;
exports.SocialAuthUrlDtoFromJSONTyped = SocialAuthUrlDtoFromJSONTyped;
exports.SocialAuthUrlDtoToJSON = SocialAuthUrlDtoToJSON;
exports.SocialAuthUrlDtoToJSONTyped = SocialAuthUrlDtoToJSONTyped;
/**
 * Check if a given object implements the SocialAuthUrlDto interface.
 */
function instanceOfSocialAuthUrlDto(value) {
    if (!('authorizationUrl' in value) || value['authorizationUrl'] === undefined)
        return false;
    if (!('provider' in value) || value['provider'] === undefined)
        return false;
    if (!('state' in value) || value['state'] === undefined)
        return false;
    return true;
}
function SocialAuthUrlDtoFromJSON(json) {
    return SocialAuthUrlDtoFromJSONTyped(json, false);
}
function SocialAuthUrlDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'authorizationUrl': json['authorizationUrl'],
        'provider': json['provider'],
        'state': json['state'],
    };
}
function SocialAuthUrlDtoToJSON(json) {
    return SocialAuthUrlDtoToJSONTyped(json, false);
}
function SocialAuthUrlDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'authorizationUrl': value['authorizationUrl'],
        'provider': value['provider'],
        'state': value['state'],
    };
}
